var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrandschutz = function SvgBrandschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.661,
    height: 87.377
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandschutz_svg__b",
    x1: 35.951,
    x2: 30.994,
    y1: 87.145,
    y2: 9.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandschutz_svg__a",
    x1: 52.128,
    x2: 44.359,
    y1: 69.118,
    y2: 12.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandschutz_svg__c",
    x1: 44.646,
    x2: 50.757,
    y1: 73.053,
    y2: 17.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandschutz_svg__d",
    x1: 1.155,
    x2: 11.85,
    y1: 56.389,
    y2: 63.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#brandschutz_svg__a",
    id: "brandschutz_svg__e",
    x1: 25.14,
    x2: 11.212,
    y1: 75.64,
    y2: 11.861
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandschutz_svg__f",
    x1: 34.524,
    x2: 34.524,
    y1: 71.937,
    y2: 16.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf3012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandschutz_svg__g",
    x1: 37.399,
    x2: 66.052,
    y1: 40.219,
    y2: 26.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#f1710f",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#f69b33",
    stopOpacity: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__b)",
    d: "M38.647 0s-4.356 17.225 20.04 36.842c22.008 17.695-.497 51.136-24.2 50.526-23.8-.612-37.906-17.437-33.771-43.504 1.618 6.472 1.258 10.427 9.708 18.337C3.412 48.358-4.677 26.966 38.647 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__a)",
    d: "m65.992 49.526-.006-.007C64.395 65.35 53.4 72.675 48.136 72.314c-10.268-.706-1.889-11.197-5.03-21.575-1.29-4.246-4.37-8.05-7.223-11.362a26.2 26.2 0 0 1-5.837-11.591q-.194-.915-.365-1.837c-.003-4.05 5.366-20.265 7.71-23.98a27.7 27.7 0 0 0 1.173 9.373c1.83 6.304 6.696 15.98 19.5 26.275a22.32 22.32 0 0 1 7.928 11.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__c)",
    d: "m65.992 49.526-.006-.007C64.395 65.35 53.4 72.675 48.136 72.314c-10.268-.706-1.889-11.197-5.03-21.575-1.29-4.246-4.37-8.05-7.223-11.362a28 28 0 0 1-5.236-10.612c-1.141-5.002 1.033-11.81 1.033-11.81-1.16 3.885-2 7.392-2 8.994a21.27 21.27 0 0 0 2.928 11.194c.262.434.537.858.815 1.283 2.506 3.775 4.985 7.388 5.698 11.969a19.47 19.47 0 0 1-1.412 10.59 31.8 31.8 0 0 1-7.067 9.89c-3.338 3.338-5.95 12.106 7.56 15.307a31.25 31.25 0 0 0 15.168-6.626 36.04 36.04 0 0 0 11.74-16.042 23.93 23.93 0 0 0 .882-13.988",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__d)",
    d: "M10.563 63.184a.98.98 0 0 1-.82-.257c-5.916-5.54-7.651-9.227-8.675-13.095 0 0 3.003 19.31 14.378 22.1 0 0-4.152-5.362-4.883-8.748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__e)",
    d: "M30.642 70.876a31.8 31.8 0 0 0 7.067-9.891 21 21 0 0 0 .976-2.86 31.4 31.4 0 0 0-.576-7.307c-.678-4.372-3.66-7.707-5.96-11.3-2.36-3.684-4.168-7.88-4.211-12.318-.053-5.373 2.728-10.214 3.064-15.5a6.9 6.9 0 0 0-.725-3.777 1.1 1.1 0 0 0-.42-.476c-.605-.308-2.053 1.231-2.505 1.583q-1.447 1.128-2.854 2.305a86 86 0 0 0-5.105 4.62 58.3 58.3 0 0 0-7.778 9.266 35 35 0 0 0-4.989 11.033c-2.33 9.678.874 17.974 4.685 25.497a.995.995 0 0 1-1.567 1.176c-5.917-5.54-7.652-9.227-8.676-13.095-.564 10.153 1.902 18.792 7.25 25.221 5.922 7.118 14.98 11.033 26.195 11.321q.307.008.615.008a25 25 0 0 0 3.065-.202c-13.5-3.204-10.888-11.968-7.55-15.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__f)",
    d: "M31.656 17.044c-.133 2.505-.603 4.942-.708 7.287a19 19 0 0 0 .108 3.412 21 21 0 0 0 .612 3.4 19.3 19.3 0 0 0 2.827 6.206 58 58 0 0 1 3.903 6.402 19.13 19.13 0 0 1 1.16 15.21 26.75 26.75 0 0 1-8.916 11.914c3.08-3.817 5.798-7.958 6.873-12.51A18.12 18.12 0 0 0 35.8 45.074c-1.064-2.074-2.458-4.007-3.791-6.112a20.6 20.6 0 0 1-3.06-7.17 24 24 0 0 1-.501-3.857 14.4 14.4 0 0 1 .414-3.914 32 32 0 0 1 2.795-6.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__g)",
    d: "m65.992 49.526-.006-.007C64.395 65.35 53.4 72.675 48.136 72.314c-10.268-.706-1.889-11.197-5.03-21.575-1.29-4.246-4.37-8.05-7.223-11.362a26.2 26.2 0 0 1-5.837-11.591q-.194-.915-.365-1.837c-.003-4.05 5.366-20.265 7.71-23.98a27.7 27.7 0 0 0 1.173 9.373c1.83 6.304 6.696 15.98 19.5 26.275a22.32 22.32 0 0 1 7.928 11.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__b)",
    d: "M38.647 0s-4.356 17.225 20.04 36.842c22.008 17.695-.497 51.136-24.2 50.526-23.8-.612-37.906-17.437-33.771-43.504 1.618 6.472 1.258 10.427 9.708 18.337C3.412 48.358-4.677 26.966 38.647 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__a)",
    d: "m65.992 49.526-.006-.007C64.395 65.35 53.4 72.675 48.136 72.314c-10.268-.706-1.889-11.197-5.03-21.575-1.29-4.246-4.37-8.05-7.223-11.362a26.2 26.2 0 0 1-5.837-11.591q-.194-.915-.365-1.837c-.003-4.05 5.366-20.265 7.71-23.98a27.7 27.7 0 0 0 1.173 9.373c1.83 6.304 6.696 15.98 19.5 26.275a22.32 22.32 0 0 1 7.928 11.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__c)",
    d: "m65.992 49.526-.006-.007C64.395 65.35 53.4 72.675 48.136 72.314c-10.268-.706-1.889-11.197-5.03-21.575-1.29-4.246-4.37-8.05-7.223-11.362a28 28 0 0 1-5.236-10.612c-1.141-5.002 1.033-11.81 1.033-11.81-1.16 3.885-2 7.392-2 8.994a21.27 21.27 0 0 0 2.928 11.194c.262.434.537.858.815 1.283 2.506 3.775 4.985 7.388 5.698 11.969a19.47 19.47 0 0 1-1.412 10.59 31.8 31.8 0 0 1-7.067 9.89c-3.338 3.338-5.95 12.106 7.56 15.307a31.25 31.25 0 0 0 15.168-6.626 36.04 36.04 0 0 0 11.74-16.042 23.93 23.93 0 0 0 .882-13.988",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__d)",
    d: "M10.563 63.184a.98.98 0 0 1-.82-.257c-5.916-5.54-7.651-9.227-8.675-13.095 0 0 3.003 19.31 14.378 22.1 0 0-4.152-5.362-4.883-8.748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__e)",
    d: "M30.642 70.876a31.8 31.8 0 0 0 7.067-9.891 21 21 0 0 0 .976-2.86 31.4 31.4 0 0 0-.576-7.307c-.678-4.372-3.66-7.707-5.96-11.3-2.36-3.684-4.168-7.88-4.211-12.318-.053-5.373 2.728-10.214 3.064-15.5a6.9 6.9 0 0 0-.725-3.777 1.1 1.1 0 0 0-.42-.476c-.605-.308-2.053 1.231-2.505 1.583q-1.447 1.128-2.854 2.305a86 86 0 0 0-5.105 4.62 58.3 58.3 0 0 0-7.778 9.266 35 35 0 0 0-4.989 11.033c-2.33 9.678.874 17.974 4.685 25.497a.995.995 0 0 1-1.567 1.176c-5.917-5.54-7.652-9.227-8.676-13.095-.564 10.153 1.902 18.792 7.25 25.221 5.922 7.118 14.98 11.033 26.195 11.321q.307.008.615.008a25 25 0 0 0 3.065-.202c-13.5-3.204-10.888-11.968-7.55-15.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__f)",
    d: "M31.656 17.044c-.133 2.505-.603 4.942-.708 7.287a19 19 0 0 0 .108 3.412 21 21 0 0 0 .612 3.4 19.3 19.3 0 0 0 2.827 6.206 58 58 0 0 1 3.903 6.402 19.13 19.13 0 0 1 1.16 15.21 26.75 26.75 0 0 1-8.916 11.914c3.08-3.817 5.798-7.958 6.873-12.51A18.12 18.12 0 0 0 35.8 45.074c-1.064-2.074-2.458-4.007-3.791-6.112a20.6 20.6 0 0 1-3.06-7.17 24 24 0 0 1-.501-3.857 14.4 14.4 0 0 1 .414-3.914 32 32 0 0 1 2.795-6.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brandschutz_svg__g)",
    d: "m65.992 49.526-.006-.007C64.395 65.35 53.4 72.675 48.136 72.314c-10.268-.706-1.889-11.197-5.03-21.575-1.29-4.246-4.37-8.05-7.223-11.362a26.2 26.2 0 0 1-5.837-11.591q-.194-.915-.365-1.837c-.003-4.05 5.366-20.265 7.71-23.98a27.7 27.7 0 0 0 1.173 9.373c1.83 6.304 6.696 15.98 19.5 26.275a22.32 22.32 0 0 1 7.928 11.91"
  }))));
};
export default SvgBrandschutz;